import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 100 90'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M36,38.9996948 L47,26.9996948 L47,62.9996948 L36,51.9996948 L28,51.9996948 C26.9977679,51.9996948 26,51 26,49.9996948 L26,40.9996948 C26.0257074,39.9997006 27,39.0150136 28,38.9996948 L36,38.9996948 Z M51,34 C54.1428729,34.1383655 56.726974,35.2106818 58.752381,37.2169811 C60.9174711,39.3616459 62,41.9559596 62,45 C62,48.0440404 60.9174711,50.6383541 58.752381,52.7830189 L58.647619,52.8867925 C56.5523705,54.9622745 54.0031896,56 51,56 L51,52.0566038 C52.8857237,52.0566038 54.4920569,51.3993776 55.8190476,50.0849057 L55.9238095,49.9811321 C57.3206419,48.5974774 58.0190476,46.9371166 58.0190476,45 C58.0190476,43.2012489 57.3206419,41.5408881 55.9238095,40.0188679 C54.5968188,38.7043959 52.9555653,38.0471698 51,38.0471698 L51,34 Z M63.011976,32.9583333 C66.337342,36.3988267 68,40.4126755 68,45 C68,49.7222458 66.337342,53.7360946 63.011976,57.0416667 C59.6866101,60.3472388 55.6826581,62 51,62 L51,58.1547619 C54.5968244,58.1547619 57.6846178,56.8730287 60.2634731,54.3095238 C62.8423283,51.7460189 64.1317365,48.6428754 64.1317365,45 C64.1317365,41.4245853 62.8423283,38.3551715 60.2634731,35.7916667 C57.8203471,33.2281618 54.7325536,31.9464286 51,31.9464286 L51,28 C55.6826581,28 59.6866101,29.6527612 63.011976,32.9583333 Z'
    />
  </svg>
)

export default SVG